import { render, staticRenderFns } from "./FieldFacilityList.vue?vue&type=template&id=2936b550&scoped=true&"
import script from "./FieldFacilityList.vue?vue&type=script&lang=js&"
export * from "./FieldFacilityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936b550",
  null
  
)

export default component.exports